export default "__VITE_ASSET__DuZc0piz__"